import React, { useState, useRef, useEffect } from "react";
import "../style/reset.css";
import "../style/theme.css";
import SiteHeader from "../components/site-header";
import SiteFooter from "./site-footer";
import { Box } from "theme-ui";
import { ThemeProvider } from "styled-components";
import theme from "../components/theme";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RouteProvider } from '../context/RouteContext'; // Assuming you're using the context approach
import { DynamicFadingContent } from "../components/dynamicPose";
import { useRouteInfo } from '../context/RouteContext';


if (typeof window !== `undefined`) {
  gsap.registerPlugin(ScrollTrigger);
  gsap.core.globals("ScrollTrigger", ScrollTrigger);
}

function testUrlForPattern(url) {
  // Define the regular expression for the pattern
  const pattern = /^\/work\/[^\/]+\/$/;
  // Test the URL against the pattern
  return pattern.test(url);
}

  ////////global layout props
const animationVariantsProps = {
standardFade: {
    exited: { opacity: 1, transition: { duration: 500 } },
    exiting: { opacity: 1, transition: { duration: 500 } },
    entered: { opacity: 1, transition: { duration: 500 } },
    enter: { opacity: 1, transition: { duration: 500 } },
},
projectPages: {
    exited: { opacity: 0,transition: { duration: 500 } },
    exiting: {opacity: 0,transition: { duration: 500 } },
    entered: { opacity: 1,transition: { duration: 500 } },
    enter: { opacity: 1,transition: { duration: 500 } },
}
};



const Layout = ({headerVariant,footerVariant,children,transitionStatus,location}) => { // Removed the duplicate 'childern' prop
    
    const navbarRef = useRef(null);
    const scrollerRef = useRef(null);
    const [visible, setVisible] = useState(true);
    const [atTheTop, setAtTheTop] = useState(true);
    let lastScrollTop = 0;

    const { previousRoute} = useRouteInfo();



    let selectedNavAnimation;

    // Define different animations based on the previous route
    if (testUrlForPattern(previousRoute)) {
        //console.log('projectPages------------------')
        selectedNavAnimation = animationVariantsProps.projectPages;
    } else {
        //console.log('standardFade--------------')
        selectedNavAnimation = animationVariantsProps.standardFade;
    }
    

    useEffect(() => {
        
        const scrollerEle = scrollerRef.current;
        const navBarWrapper = navbarRef.current;
        let scrolltriggerRefreshed = false;
        let scrolled = false;

        const handleScroll = () => {
            
            scrolled = true;

            if (scrolltriggerRefreshed == false) {
                ScrollTrigger.refresh()
                scrolltriggerRefreshed = true;
            }
            
            let currentScroll = scrollerRef.current.scrollTop;
            // Additional scrolling logic for navbar visibility
            if (currentScroll > 150 && currentScroll > lastScrollTop) {
                setVisible(false); // Hide navbar when scrolling down past 150px
                setAtTheTop(false);
            } else {
                setVisible(true); // Show navbar when scrolling up or at the top of the page
                if (currentScroll < 10) {
                setAtTheTop(true);
                } else {
                setAtTheTop(false);
                }
            }
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Update lastScrollTop for direction comparison
            
        };

        /** 
         * 
        const scrollTriggers = [];
        /// scroll trigger to check for navDark class in a section, so that we can change the colour of the nav.
        const sections = gsap.utils.toArray("section");

        function changeLogo(sec) {
            if (scrolled) {
                if (sec.classList.contains('navDark')) {
                    navBarWrapper.classList.add("positive");
                } else {
                    navBarWrapper.classList.remove("positive");
                }
            }
        }
        sections.forEach((section) => {
            const trigger = ScrollTrigger.create({
                trigger: section,
                scroller: '.scrollSnapContainer',
                start: "top 40",
                end: "bottom 40",
                onEnter: () => changeLogo(section),
                onEnterBack: () => changeLogo(section),
            });
            scrollTriggers.push(trigger);
        });

        */

      scrollerEle.addEventListener("scroll", handleScroll);

      

    return () => {
        scrollerEle.removeEventListener("scroll", handleScroll);
        //scrollTriggers.forEach(trigger => trigger.kill());
    };
}, []);



  return (
      <RouteProvider>
          <ThemeProvider theme={theme}>
              <Box
                className={`scrollSnapContainer scrollSnap scrollProvider mandatory ${ atTheTop ? "" : "nav_blur" } ${visible ? "nav_show" : "nav_hide"}`}
                variant="structure.scrollSnapContainer"
                ref={scrollerRef}
            >
                <Box as="header" className={`navBarWrapper ${headerVariant ? "positive" : "negative"}`} ref={navbarRef} variant="structure.siteHeader" >
                    <DynamicFadingContent
                        selectedAnimation={selectedNavAnimation}
                        transitionStatus={transitionStatus} >
                        <SiteHeader transitionStatus={transitionStatus} animationVariantsProps={animationVariantsProps} />
                    </DynamicFadingContent>    
                </Box>
                  {children}
                <SiteFooter footerVariant={footerVariant} location={location} />
            </Box>
        </ThemeProvider>
    </RouteProvider>
  );
};

export default Layout;
